import React from 'react';
import { SectionTitle } from './SectionTitle';
import { Chips } from './Chips';
import { CTAButton } from './CTAButton';
import { modules, product } from '../data/salesCopy';
export function ModulesSection() {
  return <section className="bg-brand-ivory px-4 py-8 sm:py-10" data-id="element-147" data-mp="1iwmkeqpumrhb">
      <div className="mx-auto max-w-4xl" data-id="element-148" data-mp="1dwqiqy4mjc4x">
        <SectionTitle data-id="element-149" data-mp="1dxt6wyakb0h5">WHAT'S INSIDE</SectionTitle>

        <div className="mt-5 space-y-3" data-id="element-150" data-mp="2bk8nlxv5zu3n">
          {modules.map(mod => <article key={mod.n} className="overflow-hidden rounded-lg border border-brand-sand/70 bg-white shadow-sm" data-id="element-151" data-mp="2bi60bllecf2m">
              <header className="flex items-center gap-2.5 bg-brand-sage px-3 py-2 sm:px-4" data-id="element-152" data-mp="21l1a9aofjzgj">
                <span className="shrink-0 rounded bg-brand-gold px-2 py-0.5 text-[10px] font-extrabold uppercase tracking-wider text-brand-charcoal" data-id="element-153" data-mp="1wly7xxzu47c9">
                  Module {mod.n}
                </span>
                <h3 className="font-serif text-[15px] font-extrabold uppercase leading-tight text-white sm:text-lg" data-id="element-154" data-mp="l71g6gc9n417">
                  {mod.title}
                </h3>
              </header>

              <div className="space-y-2.5 p-3 sm:p-4" data-id="element-155" data-mp="1nta9qhwrbsff">
                <p className="text-[13px] font-bold leading-snug text-brand-sage sm:text-[14.5px]" data-id="element-156" data-mp="1nrz4ednnycm7">
                  {mod.hook}
                </p>
                <p className="text-[12.5px] font-medium leading-snug text-brand-charcoal/85 sm:text-[13.5px]" data-id="element-157" data-mp="1dv469vvaye8g">
                  {mod.lead}
                </p>
                <Chips items={mod.bullets} data-id="element-158" data-mp="14v7f9nlfx3a8" />

                {mod.secondLead && mod.secondBullets && <>
                    <p className="text-[12.5px] font-medium leading-snug text-brand-charcoal/85 sm:text-[13.5px]" data-id="element-159" data-mp="q7mdbx0axa3w">
                      {mod.secondLead}
                    </p>
                    <Chips items={mod.secondBullets} tone="sage" data-id="element-160" data-mp="h64wudizf6eo" />
                  </>}

                {mod.notes.map(note => <p key={note} className="text-[12.5px] font-medium leading-snug text-brand-charcoal/75 sm:text-[13.5px]" data-id="element-161" data-mp="l6owpouxwo4i">
                    {note}
                  </p>)}

                <p className="border-t border-brand-sand/50 pt-2 text-[12.5px] font-extrabold uppercase leading-snug tracking-wide text-brand-clay sm:text-[13.5px]" data-id="element-162" data-mp="2e3stsnqrslxn">
                  {mod.close}
                </p>
              </div>
            </article>)}
        </div>

        <div className="mx-auto mt-6 max-w-md" data-id="element-163" data-mp="31twwmsw4whnl">
          <CTAButton subLabel={`🛡️ ${product.guarantee}`} data-id="element-164" data-mp="31v7z8pdufjd4">
            🧘 YES! I WANT THE COMPLETE SYSTEM
          </CTAButton>
        </div>
      </div>
    </section>;
}